import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class SuperAdminListService {
    paginationData: any = {};
    selectedLimit: any;
    selectedOffset: any;
    constructor(
        private _basewebservice: BaseWebService) { }

    /**
     * Service Function for Practice list
     */
    superAdminListService(limit: any, offset: any, searchKey: any, sortParam: any, order: any) {
        if (sortParam === undefined || order === undefined) {
            if (searchKey === "" || searchKey === undefined) {
                return this._basewebservice.request("v1/super_admins/?limit=" + limit + "&offset=" + offset, "get")
                    .map(res => res)
                    .catch(this.handleError);
            }
            else {
                return this._basewebservice.request("v1/super_admins/?limit=" + limit + "&offset=" + offset + "&search=" + searchKey, "get")
                    .map(res => res)
                    .catch(this.handleError);
            }
        }
        else {
            if (searchKey === "" || searchKey === undefined) {
                return this._basewebservice.request("v1/super_admins/?limit=" + limit + "&offset=" + offset + "&sort=" + sortParam + "&order=" + order, "get")
                    .map(res => res)
                    .catch(this.handleError);
            }
            else {
                return this._basewebservice.request("v1/super_admins/?limit=" + limit + "&offset=" + offset + "&search=" + searchKey + "&sort=" + sortParam + "&order=" + order, "get")
                    .map(res => res)
                    .catch(this.handleError);
            }
        }
    }

    getCities = () => {
        return this._basewebservice.request("v1/cities/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getPractices = () => {
        return this._basewebservice.request("v1/practices/?type=basic&sort=name", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getSuperAdminDetails = (id: any) => {
        return this._basewebservice.request("v1/super_admins/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    addUser(userData: any) {
        const data: any = {};
        data.body = userData;
        return this._basewebservice.request("v1/super_admins/", "post", data)
            .map(res => res)
            .catch(this.handleError);
    }

    editUser(userData: any) {
        const data: any = {};
        data.body = userData;
        return this._basewebservice.request("v1/super_admins/" + userData.id + "/", "put", data)
            .map(res => res)
            .catch(this.handleError);
    }

    deleteSuperAdmin(id: any) {
        return this._basewebservice.request("v1/super_admins/" + id + "/", "delete")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}